
import { SVGProps } from 'react';
const SvgArrowUpRight12 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 12 12"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="m3.5 8.5 5-5M3.5 3.5h5v5"
		/>
	</svg>
);
export default SvgArrowUpRight12;
